import React, { useState, useEffect } from "react";
import "./table.css"
import { Table, Pagination } from "antd";
import { color } from "./../../utils/themes/color"
import LOADING from "../loading/loading";



export default function TABLE(props) {
    var page = {};
    if (props.page != undefined && props.page != null) {
        page = props.page();
    }


    return (
        <>
            {
                props.loading
                    ? <div style={{ marginTop: "15px" }}>
                        <LOADING type={"lg"} />
                    </div>
                    :
                    <div>
                        <Table
                            rowKey="_id"
                            dataSource={props.data != undefined && props.data != null ? props.data : ""}
                            columns={props.columns != undefined && props.columns != null ? props.columns : ""}
                            pagination={false} />
                        <div style={{ width: "100%", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Pagination
                                className="table-pagination"
                                current={page.current != undefined && page.current != null ? page.current : ""}
                                total={page.total != undefined && page.total != null ? page.total : ""}
                                pageSize={page.pageSize != undefined && page.pageSize != null ? page.pageSize : ""}
                                style={{ color: color.primary }}
                                onChange={(e) => props.page(e)} />
                        </div>
                    </div>
            }
        </>
    )
}





